import Core from '../../Core';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import colors from '../../../styles/colors';
import { UserRetrieveProps } from '../types';
import * as api from '../../../services/api';
import { IconContext } from 'react-icons/lib';
import CardSomos from '../../../components/Card';
import { useAuth } from '../../../hooks/useAuth';
import { CompanyProps } from '../../Company/types';
import { useCallback, useEffect, useState } from 'react';
import useWindowSize from '../../../hooks/useWindowSize';
import { useParams, useLocation } from 'react-router-dom';
import HubRoundedIcon from '@mui/icons-material/HubRounded';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import BlockRoundedIcon from '@mui/icons-material/BlockRounded';
import { DefaultMessage } from '../../../utils/defaultMessages';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import {
  FaRegSun,
} from 'react-icons/fa';
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded';
import {
  FormControl,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { TextFieldsGrid } from '../../../components/CreateOrUpdateCompany/TextFieldsGrid';
import { userValidationSchema } from '../../../components/CreateOrUpdateUser/userValidationSchema';
import { PlanSelectorChip } from '../../../components/CreateOrUpdateCompany/PlanSelectorChip';
import { ProductChips } from '../../../components/CreateOrUpdateUser/ProductChips';
import { handleAddProduct } from '../../../components/CreateOrUpdateCompany/Helpers';
import BooleanChips from '../../../components/CreateOrUpdateCompany/BooleanChips';
import Info from '../../../components/CreateOrUpdateCompany/Info';
import { productsData } from '../../../components/CreateOrUpdateCompany/FormFields';
import { ProductItem } from '../../../components/CreateOrUpdateCompany/ProductItem';
import { getReCaptchaToken, loadReCaptchaScript, removeReCaptchaScript } from '../../../utils/Recaptcha';
import { ButtonInverse } from '../../../components/ButtonInverse';

const colheitadeira = require('../../../images/colheitadeiraBranca.png');
const colheitadeiraCinza = require('../../../images/colheitadeiraCinza.png');
// const colheitadeiraBranca = require("../../../images/colheitadeiraBranca.png")
// const colheitadeiraPreta = "https://img.icons8.com/material-rounded/96/harvester.png";

export default function CreateOrUpdateUser(): JSX.Element {
  const { id } = useParams();
  const { user } = useAuth();
  const location = useLocation();
  const { width } = useWindowSize();

  const [data, setData] = useState<UserRetrieveProps>();
  const [companies, setCompanies] = useState<CompanyProps[]>();
  const [selectedCompanyData, setSelectedCompanyData] = useState<CompanyProps | null>(null);

  useEffect(() => {
    if (location.pathname === '/new-user' || location.pathname === `/user/${id}`) {
      loadReCaptchaScript()
    }
    return () => {
      if (location.pathname === '/new-user'|| location.pathname === `/user/${id}`) removeReCaptchaScript();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const { handleChange, handleSubmit, values, setFieldValue, errors, touched } = useFormik({
    initialValues: {
      first_name: '',
      last_name: '',
      email: '',
      company: 'company-selected',
      products: [],
      api_user: false,
      blocked: false,
      can_upload_table: false,
      is_representative: false,
      can_manage_query_chassi_or_plate: false,
      can_download_full_table: false,
      is_admin: false,
      plan: '1',
      cr_balance: 0,
      hp_balance: 0,
      sr_balance: 0,
      tr_balance: 0,
      cm_balance: 0,
      hv_balance: 0,
      lw_balance: 0,
    },
    onSubmit: createOrUpdateUser,
    validationSchema: userValidationSchema,
  });

  useEffect(() => {
    const selectedCompany = localStorage.getItem('selected_company')
    if (selectedCompany) {
      const company = JSON.parse(selectedCompany)
      setSelectedCompanyData(company)
    }
  }, [])
  // const addProduct = (value: string) => {
  //   let products: string[] = values.products;
  //   if (products.filter((item) => item === value).length > 0) {
  //     let index = products.indexOf(value);
  //     products.splice(index, 1);
  //     setFieldValue('products', products);
  //   } else {
  //     products.push(value);
  //     setFieldValue('products', products);
  //   }
  // };

  const getCompanies = async () => {
    await api
      .get('company/list/')
      .then((response: any) => {
        if (response.status === 200) {
          setCompanies(response.data.content);
        } else {
          toast.error(response.data.content, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => {
        toast.error(DefaultMessage.ERROR, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const getData = useCallback(async () => {
    await api
      .get(`user/retrieve/${id}/`)
      .then((response: any) => {
        if (response.status === 200) {
          setFieldValue('first_name', response.data.content.first_name);
          setFieldValue('last_name', response.data.content.last_name);
          setFieldValue('email', response.data.content.email);
          setFieldValue(
            'company',
            response.data.content.company_id ?? 'company-selected',
          );
          setFieldValue('api_content', response.data.content.api_content);
          setFieldValue('api_user', response.data.content.api_user);
          setFieldValue('products', response.data.content.products);
          setFieldValue('blocked', response.data.content.blocked);
          setFieldValue(
            'is_representative',
            response.data.content.is_representative,
          );
          setFieldValue('is_admin', response.data.content.is_admin);
          setFieldValue(
            'can_upload_table',
            response.data.content.can_upload_table,
          );
          setFieldValue(
            'can_download_full_table',
            response.data.content.can_download_full_table,
          );
          setFieldValue(
            'can_manage_query_chassi_or_plate',
            response.data.content.can_manage_query_chassi_or_plate,
          );
          if (response.data.content.is_admin) {
            setFieldValue('plan', '1');
            setFieldValue('cr_balance', 0);
            setFieldValue('hp_balance', 0);
            setFieldValue('tr_balance', 0);
            setFieldValue('sr_balance', 0);
            setFieldValue('lw_balance', 0);
            setFieldValue('cm_balance', 0);
            setFieldValue('hv_balance', 0);
          } else {
            setFieldValue('plan', response.data.content.plan_balance.plan);
            setFieldValue(
              'cr_balance',
              response.data.content.plan_balance.cr_balance,
            );
            setFieldValue(
              'hp_balance',
              response.data.content.plan_balance.hp_balance,
            );
            setFieldValue(
              'tr_balance',
              response.data.content.plan_balance.tr_balance,
            );
            setFieldValue(
              'sr_balance',
              response.data.content.plan_balance.sr_balance,
            );
            setFieldValue(
              'cm_balance',
              response.data.content.plan_balance.cm_balance,
            );
            setFieldValue(
              'hv_balance',
              response.data.content.plan_balance.hv_balance,
            );
            setFieldValue(
              'lw_balance',
              response.data.content.plan_balance.lw_balance,
            );
          }

          setData(response.data);
        } else {
          toast.error(response.data.content, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => {
        toast.error(DefaultMessage.ERROR, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  }, [id, setFieldValue]);

  const handleChangeCompany = (e: SelectChangeEvent<string>) => {
    let value = e.target.value;
    setFieldValue('company', value);
    if (value !== 'company-selected') {
      const selectedCompany = companies?.find((c) => c.id === value) || null;
      setSelectedCompanyData(selectedCompany);
      setFieldValue('can_upload_table', false);
      setFieldValue('can_manage_query_chassi_or_plate', false);
      setFieldValue('is_admin', false);
    } else {
      setSelectedCompanyData(null)
      setFieldValue('is_representative', false);
      setFieldValue('api_user', false);
    }
  };

  async function createOrUpdateUser() {
    toast.loading('Aguarde...', {
      position: toast.POSITION.TOP_RIGHT,
    });
    await loadReCaptchaScript();
    const freshToken = await getReCaptchaToken('user_create');
    
    const createUrl = `user/create/`;
    const updateUrl = `user/update/${data?.content.id}/`;

    let payload;

    if (user?.is_staff || user?.is_admin) {
      payload = values;
    } else {
      payload = {
        first_name: values.first_name,
        last_name: values.last_name,
        email: values.email,
        products: values.products,
        blocked: values.blocked,
        can_download_full_table: values.can_download_full_table,
      };
    }

    if (id) {
      await api
        .put(updateUrl, payload)
        .then((response: any) => {
          toast.dismiss();
          if (response.status === 200) {
            toast.success('Usuário atualizado com sucesso!', {
              position: toast.POSITION.TOP_RIGHT,
            });
          } else {
            toast.error(response.data.content, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        })
        .catch((error) => {
          toast.dismiss();
          toast.error(DefaultMessage.ERROR, {
            position: toast.POSITION.TOP_RIGHT,
          });
        });
    } else {
      if (freshToken)
        await api
          .post(createUrl, payload, { recaptcha_token: freshToken })
          .then((response: any) => {
            toast.dismiss();
            if (response.status === 201) {
              toast.success('Usuário cadastrado com sucesso!', {
                position: toast.POSITION.TOP_RIGHT,
              });
            } else {
              toast.error(response.data.content, {
                position: toast.POSITION.TOP_RIGHT,
              });
            }
          })
          .catch((error) => {
            toast.dismiss();
            toast.error(DefaultMessage.ERROR, {
              position: toast.POSITION.TOP_RIGHT,
            });
          });
    }
  }

  useEffect(() => {
    if (id) getData();

    if (user?.is_staff || user?.is_admin) {
      getCompanies();

      // @ts-ignore
      if (location.state?.value) {
        // @ts-ignore
        setFieldValue('company', location.state.value.company_id);
      }
    }
  }, [getData, id, user?.is_admin, user?.is_staff, location, setFieldValue]);

  const styleContainerData = {
    display: width < 900 ? 'block' : 'flex',
    alignItems: width < 900 ? 'center' : 'end',
  }
  return (
    <IconContext.Provider value={{ size: '18' }}>
      <Core
        withBlueBar
        withNavbar
        path={
          id
            ? data?.content.company_id
              ? user?.is_staff || user?.is_admin
                ? `/users/${data?.content.company_id}`
                : `/users/company/${data?.content.company_id}`
              : ''
            : ''
        }
        label={
          id
            ? data?.content.company_id
              ? user?.is_staff || user?.is_admin
                ? `Clique aqui para voltar a listagem de usuários da empresa ${data?.content.company_name}`
                : 'Clique aqui para voltar a listagem de usuários'
              : ''
            : ''
        }
      >
        <Grid
          container
          direction="column"
          alignContent="center"
          alignItems="center"
          textAlign="center"
          paddingBottom={10}
        >
          <form onSubmit={handleSubmit}>
            <Grid
              container
              spacing={2}
              textAlign="center"
              justifyContent="space-around"
              paddingX={2}
              style={{ flexDirection: width <= 600 ? 'column' : 'row', paddingRight: '0' }}
            >
              {user?.is_staff || user?.is_admin ? (
                <Grid item md={12} sm={12} marginBottom='1rem'>
                  <FormControl>
                    <Select
                      labelId="company-label"
                      id="company-select"
                      name="company"
                      value={values.company}
                      onChange={handleChangeCompany}
                      variant="outlined"
                    >
                      <MenuItem value="company-selected">
                        Selecione a empresa
                      </MenuItem>
                      {companies?.map((item, index) => (
                        <MenuItem key={`company-${index}`} value={item.id}>
                          {item.social_reason}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              ) : (
                <></>
              )}
              <TextFieldsGrid
                fields={[
                  { name: 'first_name', label: 'Nome', type: 'text' },
                  { name: 'last_name', label: 'Sobrenome', type: 'text' },
                  { name: 'email', label: 'E-mail', type: 'email' },
                ]}
                sx={width > 1200 ? { width: 330 } : undefined}
                values={values}
                setFieldValue={setFieldValue}
                handleChange={handleChange}
                errors={errors}
                touched={touched}
              />
              {values.company !== 'company-selected' ||
                user?.is_representative ? (
                <ProductChips
                  user={user}
                  values={values}
                  addProduct={(id) => handleAddProduct(id, values, setFieldValue)}
                  colheitadeira={colheitadeira}
                  colheitadeiraCinza={colheitadeiraCinza}
                />

              ) : (
                <></>
              )}
              {user?.is_staff || user?.is_admin ? (
                <>
                  {values.company !== 'company-selected' ? (
                    <BooleanChips
                      md={10}
                      styleContainer={styleContainerData}
                      paddingX='16px'
                      mb='0'
                      items={[
                        { name: 'is_representative', label: 'É o responsável pela empresa?', icon: <AssignmentIndIcon /> },
                        { name: 'api_user', label: 'Permitir integração?', icon: <HubRoundedIcon /> },
                      ]}
                      values={values}
                      setFieldValue={setFieldValue}
                    />
                  ) : (
                    <></>
                  )}

                  {user?.is_staff && values.company === 'company-selected' ? (
                    <>
                      <BooleanChips
                        md={4}
                        styleContainer={styleContainerData}
                        paddingX='16px'
                        mb='0'
                        items={[
                          { name: 'is_admin', label: 'Administrador?', icon: <AdminPanelSettingsRoundedIcon /> },
                        ]}
                        values={values}
                        setFieldValue={setFieldValue}
                      />
                      {values.is_admin ? (
                        <>
                          <BooleanChips
                            md={4}
                            styleContainer={styleContainerData}
                            paddingX='16px'
                            mb='0'
                            items={[
                              { name: 'can_upload_table', label: 'Pode adicionar planilhas?', icon: <CloudUploadIcon /> },
                              { name: 'can_manage_query_chassi_or_plate', label: 'Pode Gerenciar Precificador?', icon: <FaRegSun /> },
                              { name: 'can_download_full_table', label: 'Permitir fazer download tabela full?', icon: <HubRoundedIcon /> },
                            ]}
                            values={values}
                            setFieldValue={setFieldValue}
                          />
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <></>
              )}
              {selectedCompanyData?.can_download_full_table === true && (
                <BooleanChips
                  md={4}
                  styleContainer={styleContainerData}
                  paddingX='16px'
                  mb='0'
                  items={[
                    { name: 'can_download_full_table', label: 'Permitir fazer download tabela full?', icon: <HubRoundedIcon /> },
                  ]}
                  values={values}
                  setFieldValue={setFieldValue}
                />
              )}
              <BooleanChips
                md={4}
                styleContainer={styleContainerData}
                paddingX='16px'
                mb='0'
                items={[
                  { name: 'blocked', label: 'Bloquear?', icon: <BlockRoundedIcon /> },
                ]}
                values={values}
                setFieldValue={setFieldValue}
              />
              {user?.is_staff &&
                values.company === 'company-selected' &&
                values.is_admin !== true && (
                  <>
                    <PlanSelectorChip value={values.plan} setValue={(val: any) => setFieldValue('plan', val)} />
                    <CardSomos>
                      <Grid container textAlign="center" justifyContent="center" spacing={4}>
                        <Info values={values} />
                        {productsData.map(product => (
                          <ProductItem
                            key={product.id}
                            product={product}
                            values={values}
                            addProduct={(id) => handleAddProduct(id, values, setFieldValue)}
                            handleChange={handleChange}
                            colors={colors}
                            colheitadeira={colheitadeira}
                          />
                        ))}
                      </Grid>
                    </CardSomos>
                  </>
                )}
              <Grid item md={12} xs={12}>
                <ButtonInverse
                  variant="contained"
                  size="large"
                  color="secondary"
                  type="submit"
                >
                  {id ? 'Atualizar' : 'Cadastrar'}
                </ButtonInverse>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Core>
    </IconContext.Provider>
  );
}